import React, { useState } from 'react';
import { Star } from 'lucide-react';

interface Props {
  value?: number;
  onChange?: (v: number) => void;
  readOnly?: boolean;
  size?: 'sm' | 'md';
}

export const CustomerRatingStars: React.FC<Props> = ({ value = 0, onChange, readOnly = false, size = 'md' }) => {
  const [hover, setHover] = useState<number | null>(null);
  const editable = !readOnly && !!onChange;
  const starSize = size === 'sm' ? 'w-3.5 h-3.5' : 'w-5 h-5';

  return (
    <div className="inline-flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => {
        const active = (hover ?? value) >= star;
        return (
          <button
            key={star}
            type="button"
            disabled={!editable}
            onClick={() => editable && onChange?.(star)}
            onMouseEnter={() => editable && setHover(star)}
            onMouseLeave={() => editable && setHover(null)}
            className={`transition-transform ${editable ? 'cursor-pointer hover:scale-110' : 'cursor-default'} ${editable ? '' : 'pointer-events-none'}`}
            title={editable ? `${star} von 5` : undefined}
            aria-label={`${star} Sterne`}
          >
            <Star
              className={`${starSize} transition-colors ${active ? 'text-amber-400 fill-amber-400' : 'text-slate-300'}`}
            />
          </button>
        );
      })}
    </div>
  );
};
